import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm, ProFormRadio, ProFormDependency, ProFormTextArea, ProFormSelect } from '@ant-design/pro-components'

const getData = (data, type) => (
  data
    .filter(e => e.type == type)
    .map(e => ({ url: e.url, filename: e.fileName }))
)

export default function ({ store, params, navigator }) {
  const fileType = React.useMemo(() => {
    return store.config.getConstantPairs('FileType')
  }, [])

  const res = useRequest<any, any>(async () => {
    const result = await store.externals.api.get(`/quotations/${params.id}`)

    return Object.assign(result, {
      formData: Object.assign(R.pick([
          'payStatus'
        , 'isDeposit'
        , 'noDepositReason'
      ], result), {
        receipt: getData(result.fileManageList, fileType.receiptVoucher),
        excel: getData(result.fileManageList, fileType.quotationFile),
      })
    })
  }, {
    manual: true
  })

  const handleSave = useRequest(async (data, type) => {
    return store.externals.api.put(`/quotations/upload/${params.id}?type=${type}`, data.map(elm => {
      return {
        url: elm.url,
        fileName: elm.filename,
      }
    }))
  }, {
    manual: true,
  })

  return <div className='p-4 m-4 bg-white'>
    <Spin spinning={res.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300 mb-2'>
        <tbody>
          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>客户姓名</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerName}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>电话</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerPhone}</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>设计师</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.designerName}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>来源</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerSource}</td>
          </tr>
        </tbody>
      </table>
    </Spin>

    <ProForm
      rowProps={{ gutter: 24 }}
      layout='vertical'
      request={() => res.runAsync().then(R.prop('formData'))}
      onReset={() => navigator.back()}
      onFinish={data => store.externals.api.put(`/quotations/${params.id}`, data).then(() => navigator.back())}
      initialValues={{ isDeposit: 'yes' }}
      readonly={!store.identity.hasPermission('/price/list:upload')}
      submitter={!store.identity.hasPermission('/price/list:upload') ? false : {
        searchConfig: {
          submitText: '提交',
          resetText: '返回',
        },
      }}
    >
      <UploadImage
        max={10000}
        name='receipt'
        label='上传收款凭证'
        help='建议尺寸800*800px'
        readonly={!store.identity.hasPermission('/price/list:upload')}
        onSave={e => handleSave.runAsync(e, fileType.receiptVoucher)}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />

      <UploadFile
        max={10}
        name='excel'
        label='报价xls文件存档'
        readonly={!store.identity.hasPermission('/price/list:upload')}
        onSave={e => handleSave.runAsync(e, fileType.quotationFile)}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />

      <ProFormRadio.Group
        name='isDeposit'
        label='客户是否已交订金'
        rules={[ { required: true, message: '请确认客户是否已交订金' } ]}
        options={[
          {
            label: '已交',
            value: 'yes',
          },
          {
            label: '未交',
            value: 'no',
          },
        ]}
      />

      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'no') {
            return null
          }

          return <ProFormSelect
            name='payStatus'
            label='收款方式（如预设不符合可自填）'
            width='xl'
            rules={[ { required: true, message: '请填写收款方式' } ]}
            fieldProps={{ mode: 'tags' }}
            convertValue={value => R.is(Array, value) ? value : value?.split(',') ?? []}
            transform={value => R.is(Array, value) ? value.join(',') : value}
            valueEnum={store.config.getConstantEnums(`PaymentType`)}
          />
        }}
      </ProFormDependency>

      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'yes') {
            return null
          }

          return <ProFormTextArea
            name='noDepositReason'
            label='没有收款下单原因'
            fieldProps={{ rows: 6 }}
            rules={[ { required: true, message: '请填写没有收款下单原因' } ]}
          />
        }}
      </ProFormDependency>
    </ProForm>
  </div>
}
